import React, {createRef, RefObject} from 'react';
import Popover from "../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from '../../../gd-components/gd-popover/popover-position';
import PopoverHelpHint from "../../../gd-components/popover-menu/popover-help-hint/popover-help-hint";
import {PopoverHeightRestriction} from "../../../gd-components/gd-popover/@const";


type Props = {
    field               : any
    getTarget           : any
    hint?               : boolean,   // if true - show hint messages
    onStatusSelect      : onChangeCallback,
    hidePopover         : onChangeCallbackOptionalValue,
    togglePopover       : callback,

    // POPOVER ATTACHMENT
    popoverPosition     : PopoverPosition
}

export default class ExpenseStatusSelectorPopover extends React.Component<Props, any> {

    private refHintMessage  : RefObject<PopoverHelpHint>

    constructor(props:Props) {
        super(props);

        this.refHintMessage   = createRef()
    }

    onStatusClick = (statusId: number) => {
        this.props.onStatusSelect(statusId)
    }

    handleHoverOn = (info:string|null) => {
        if (!this.props.hint) return

        this.refHintMessage?.current?.setMessage(info)
    }

    handleHoverOff = () => {
        if (!this.props.hint) return
        this.refHintMessage?.current?.setMessage(null)
    }

    render() {

        return (
            <Popover popoverClass="gd-select-status-popover"
                     position={this.props.popoverPosition}
                     constraints={this.props.popoverPosition.constrains}
                     onClickOutside={()=>{this.props.hidePopover()}}
                     getTargetFunc={this.props.getTarget}
                     heightRestriction={PopoverHeightRestriction.HALF_WINDOW_HEIGHT}>

                <div className="ui5-popover-menu">
                    {this.props.field.options.map((option: Option, key: number)=>{

                        const labelClass = Classes('label ui5-txt-status-name',
                            'gd-scf-'+option.color,
                        );

                        return (
                            <div key={key} className="option" onClick={this.onStatusClick.bind(this, option.value)}>
                                <div className={labelClass}>{option.label}</div>
                            </div>
                        )
                    })}
                </div>
            </Popover>
        );
    }
}
